import { useRootSelector } from '../../../../../store/hooks';
import { selectAudienceHubLayout } from '../../store/features/layout';
import { selectAudienceHubOptions } from '../../store/features/options';
import s from './NotFound.module.scss';
import StaticPageLayout from '../../layouts/StaticPageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import PageNotFound from '../../../shared/PageNotFound';

export default function NotFound() {
  const { data } = useRootSelector(selectAudienceHubLayout);
  const brandLogo = data?.header?.headerNavBar?.brandLogo;
  const {
    data: { name: hubName },
  } = useRootSelector(selectAudienceHubOptions);

  return (
    <StaticPageLayout className={s.body}>
      <MetaTags
        title="Not Found"
        titleSuffix={hubName}
        thumbnail={brandLogo?.path}
      />
      <PageNotFound />
    </StaticPageLayout>
  );
}
